import github from "../../assets/github.png";
import insta from "../../assets/insta.png";
import linkedin from "../../assets/linkedin.png";
import mail from "../../assets/mail.png";
import whatsapp from "../../assets/whatsapp.png";
import facebook from "../../assets/facebook.png";
import AppImage from "../AppImage/AppImage";

import "./index.css";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="social-icons">
        <a
          href="https://github.com/marcelogomes90"
          target="_blank"
          rel="noreferrer"
          aria-label="GitHub"
        >
          <AppImage className="social" src={github} alt="github" />
        </a>
        <a
          href="https://www.instagram.com/marcelogomes90/"
          target="_blank"
          rel="noreferrer"
          aria-label="Instagram"
        >
          <AppImage className="social" src={insta} alt="instagram" />
        </a>
        <a
          href="https://www.linkedin.com/in/marcelogomes90/"
          target="_blank"
          rel="noreferrer"
          aria-label="LinkedIn"
        >
          <AppImage className="social" src={linkedin} alt="linkedin" />
        </a>
        <a
          href="mailto:marcelo.sobrinho@outlook.com"
          target="_blank"
          rel="noreferrer"
          aria-label="Email"
        >
          <AppImage className="social" src={mail} alt="email" />
        </a>
        <a
          href="https://api.whatsapp.com/send?phone=5581998066509"
          target="_blank"
          rel="noreferrer"
          aria-label="WhatsApp"
        >
          <AppImage className="social" src={whatsapp} alt="whatsapp" />
        </a>
        <a
          href="https://web.facebook.com/profile.php?id=100025656512992"
          target="_blank"
          rel="noreferrer"
          aria-label="Facebook"
        >
          <AppImage className="social" src={facebook} alt="facebookP" />
        </a>
      </div>
      <p className="footer-title">Desenvolvido por Marcelo Gomes © {currentYear}</p>
    </footer>
  );
}

export default Footer;
